import * as React from 'react'
import { useState, useCallback, useEffect } from 'react'

import Accordion from './Accordion/Accordion'
import Summary from './Accordion/Summary'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Details from '@mui/material/AccordionDetails'
import ExpandMore from '@mui/icons-material/ExpandMore'

interface Props {
  label: string
  subLabel?: (expanded: boolean) => React.ReactNode
  reset?: boolean
  children: React.ReactNode
}

function CollapsibleFilter(props: Props) {
  const { label, subLabel, children, reset } = props

  const [expanded, setExpanded] = useState(false)

  const onChange = useCallback(
    (_e: React.ChangeEvent<unknown>, expanded: boolean) =>
      setExpanded(expanded),
    [],
  )

  useEffect(() => {
    if (reset) {
      setExpanded(false)
    }
  }, [reset, setExpanded])

  return (
    <Accordion
      expanded={expanded}
      onChange={onChange}
      elevation={0}
      TransitionProps={{ unmountOnExit: true }}
    >
      <Summary expandIcon={<ExpandMore />}>
        <Box mr={1}>{label}</Box>
        {!!subLabel && (
          <Box
            overflow="hidden"
            ml="auto"
            fontSize="12px"
            fontWeight={500}
            color="#0e54b7"
          >
            <Typography
              noWrap
              style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
            >
              {subLabel(expanded)}
            </Typography>
          </Box>
        )}
      </Summary>
      <Details>{children}</Details>
    </Accordion>
  )
}

export default CollapsibleFilter
